import { render } from "./TransferIndexPage.vue?vue&type=template&id=06866423"
import script from "./TransferIndexPage.vue?vue&type=script&lang=js"
export * from "./TransferIndexPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__